import React from 'react'
import { TableBodyProps } from '../types'

const TableBody: React.FC<TableBodyProps> = ({ children }) => <tbody>{children}</tbody>

export default TableBody
